import React from "react";


export default function PartRow({part}){

    let customer_cost = Math.round((part.customer_cost + Number.EPSILON) * 100) / 100
    return (
        <tr>
            <td>{part.part_number}</td>
            <td>{part.name}</td>
            <td>£{customer_cost}</td>
        </tr>
    )


}